module.exports = __webpack_public_path__ + "img/map2.9e8d5809.jpg";